export default {
    apiServerUrl: 'https://sklad-ph-wp.thecamels.pl/'
};
